import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

import { ref, watch, computed, defineAsyncComponent } from 'vue'
    import { useElementSize } from '@vueuse/core'
    import { useChatStore } from '@/stores/chat'

    import { DataDetails } from '@/hooks/useViewDetails'
    import useDetails from '@/hooks/useViewDetails'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeChart',
  props: {
        mobile: { default: false, type: Boolean }
    },
  setup(__props) {

const prop = __props

    const ChatSidebar = defineAsyncComponent(() => import('./ChatSidebar.vue'))
    const ChatContent = defineAsyncComponent(() => import('./ChatContent.vue'))
    const ChatDetails = defineAsyncComponent(() => import('./Details/ChatDetails.vue'))
    const ChatTransition = defineAsyncComponent(() => import('@/components/Utils/ChatTransition.vue'))

    

    const el = ref<HTMLDivElement | null>(null)
    const isMobile = ref<boolean>(prop.mobile)

    const chatStore = useChatStore()
    const { width } = useElementSize(el)
    const { details } = useDetails()

    const isViewDetails = computed<DataDetails>(() => details.value )
    const isViewSidebar = computed(() => { return isMobile.value ? !(chatStore.getSelected?.id) : true })
    const isViewMessage = computed(() => { return isMobile.value ? !!(chatStore.getSelected?.id) : true })

    watch(() => width.value, newValue => {
        if (prop.mobile) {
            isMobile.value = newValue < 726
        }
    })

    watch(() => prop.mobile, newValue => {
        isMobile.value = newValue
    })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex h-full pt-10 relative",
    ref_key: "el",
    ref: el
  }, [
    _withDirectives(_createVNode(_unref(ChatSidebar), { mobile: isMobile.value }, null, 8, ["mobile"]), [
      [_vShow, _unref(isViewSidebar)]
    ]),
    _withDirectives(_createVNode(_unref(ChatContent), { mobile: isMobile.value }, null, 8, ["mobile"]), [
      [_vShow, _unref(isViewMessage)]
    ]),
    _createVNode(_unref(ChatTransition), { show: true }, {
      default: _withCtx(() => [
        (_unref(isViewDetails).status)
          ? (_openBlock(), _createBlock(_unref(ChatDetails), { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}
}

})